import {Component, Input} from "@angular/core";
import {RESTRICTION_TYPES_LIST} from "../../enums/e-restrictions";
import {UI_TEXTS} from "../../enums/e-texts";
import {inputUtils} from "../../helpers/input-utils";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {IRestriction} from "../../services/factory-service-impl/restriction.utils";


@Component({
  selector: "nv-restrictions",
  templateUrl: "./nv-restrictions.component.html"
})
export class NvRestrictionsComponent {
  UI_TEXTS = UI_TEXTS;

  private _document: any;
  private _pointer: string;
  private _small: boolean;
  private _title: string;
  private _selected: IRestriction;

  public size = {
    table: 0,
    child: 0
  };

  @Input() set title(v: string) {
    this._title = v;
  }

  @Input() set pointer(v: string) {
    this._pointer = v;
    this.updateModel();
  }

  @Input() set document(v: any) {
    this._document = v;
    this.updateModel();
  }

  @Input() set small(v: boolean) {
    if (this._small = v) {
      this.resizeToSmallLayout();
    } else {
      this.resizeToNormalLayout();
    }
  }


  get pointer(): string { return this._pointer; }
  get document(): any { return this._document; }
  get title(): string { return this._title || "NO TITLE"; }
  get selected(): IRestriction { /*console.log(this._selected);*/ return this._selected; }
  get restrictions(): IRestriction[] {
    return JP.get(this.document, this.pointer);
  }

  constructor(private factoryService: FactoryService) {
    this.small = false;
  }


  getLabel(restrictionObj: IRestriction) {
    // todo: use as a dict to improve search!
    for (let i = 0; i < RESTRICTION_TYPES_LIST.length; ++i) {
      let r = RESTRICTION_TYPES_LIST[i];
      if (r.id == restrictionObj.key) {
        return r.label;
      }
    }
    return `invalid restr.key ${restrictionObj.key}`;
  }


  onItemSelected(r: IRestriction) {
    this._selected= r;
  }





  onAddClick() {
    this.factoryService.addRestrictionTo(this.document, this.pointer);
  }


  private updateModel() {
    inputUtils.initializeArrayIfMissing(this.document, this.pointer);
  }


  private resizeToSmallLayout() {
    this.size.table = 5;
    this.size.child = 7;
  }


  private resizeToNormalLayout() {
    this.size.table = 4;
    this.size.child = 8;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-restrictions/nv-restrictions.component.ts